exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-dropdown-link[data-v-482cf72d] {\n  padding: 0 0 0 10px;\n  color: #ff0200;\n}\n", ""]);

// exports
